import { Badge, Flex, Text } from "@chakra-ui/react";
import { SeV2AttachmentDto, SeV2AttachmentSource } from "../../../autogen/bff-api";
import { DownloadDocumentIconButton } from "../../documents/DownloadDocumentIconButton/DownloadDocumentIconButton";
import { useAttachmentSourceLabel } from "./attachmentSource";

const sourceChip: Record<SeV2AttachmentSource, { bg: string; fg: string }> = {
  [SeV2AttachmentSource.Request]: { bg: "smChipBlueBg", fg: "smChipBlueFg" },
  [SeV2AttachmentSource.Offer]: { bg: "smChipVioletBg", fg: "smChipVioletFg" },
  [SeV2AttachmentSource.Upload]: { bg: "smChipTealBg", fg: "smChipTealFg" },
};
// Neutral fallback so an unrecognized source (e.g. a value the client enum doesn't know yet) renders a chip
// instead of crashing the whole thread on `chip.bg`.
const fallbackChip = { bg: "smBorder", fg: "smText" };

export const AttachmentList = ({
  eventId,
  attachments,
}: {
  // Optional: when the sourcing-event id is unknown (e.g. the contract-origin view without an event link),
  // attachments are still listed but not downloadable — the download route is event-scoped.
  eventId?: string;
  attachments?: SeV2AttachmentDto[];
}) => {
  const sourceLabel = useAttachmentSourceLabel();
  if (!attachments || attachments.length === 0) return null;
  return (
    <Flex direction="column" gap="1" mt="2">
      {attachments.map((attachment) => {
        const chip = sourceChip[attachment.source] ?? fallbackChip;
        return (
          <Flex key={attachment.documentId} alignItems="center" gap="2">
            {eventId && (
              <DownloadDocumentIconButton documentId={attachment.documentId} eventId={eventId} size="sm" />
            )}
            <Text fontSize="sm">{attachment.fileName}</Text>
            <Badge bg={chip.bg} color={chip.fg}>
              {sourceLabel(attachment.source)}
            </Badge>
          </Flex>
        );
      })}
    </Flex>
  );
};
